import { Button, Popconfirm, TableProps, Tag } from "antd";
import { IMultiLanguage } from "../../types/MutliLanguage";
import { Top10RichtTextDataType } from "../Top10Articles/types";
import TitlePopOver from "../Articles/Components/TitlePopover";
import { Link } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { CiTrash } from "react-icons/ci";
import { TbImageInPicture } from "react-icons/tb";
import Top10ArticlesCategoriesPopOver from "./Components/Top10ArticlesCategoriesPopOver";
import { ITop10Article } from "../../types/Top10Article";

export interface MainWebsiteTableDataType {
  id: string;
  title: IMultiLanguage;
  image: string;
  keywords: IMultiLanguage[];
}

export interface MainWebsiteCategoryTableDataType {
  id: string;
  title: IMultiLanguage;
  image: string;
  keywords: IMultiLanguage[];
  top10articles: ITop10Article[];
}

export const CategoryRichtTextColumns = (
  mainWebsiteId: string,
  categoryId: string,
  page: number,
  pageSize: number,
  handleDelete: (id: string) => void
): TableProps<Top10RichtTextDataType>["columns"] => [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        <TitlePopOver value={record.title} />
      </div>
    ),
  },
  {
    title: "Actions",
    dataIndex: "id",
    key: "actions",
    render: (_, record) => (
      <div className="flex gap-2">
        <Link
          to={`/main-websites/manage-categories/${mainWebsiteId}/manage-rich-text/${categoryId}/edit-rich-text/${
            record.id
          }?page=${page + 1}&pageSize=${pageSize}`}
        >
          <Button type="link" icon={<EditOutlined />} />
        </Link>
        <Popconfirm
          title="Are you sure you want to delete this text?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="dashed" danger icon={<CiTrash />} />
        </Popconfirm>
      </div>
    ),
  },
];

export const CategoriesColumns = (
  mainWebsiteId: string,
  page: number,
  pageSize: number,
  handleDelete: (id: string) => void
): TableProps<MainWebsiteCategoryTableDataType>["columns"] => [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        <TitlePopOver value={record.title} />
        <Link
          to={`/main-websites/manage-categories/${mainWebsiteId}/edit-title/${
            record.id
          }?page=${page + 1}&pageSize=${pageSize}`}
        >
          <Button type="link">
            <EditOutlined />
          </Button>
        </Link>
      </div>
    ),
  },
  {
    title: "Keywords",
    dataIndex: "keywords",
    key: "keywords",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        {record.keywords.map((key: IMultiLanguage) => (
          <Tag
            title={`${key.Ar} - ${key.Fr}`}
            className="flex justify-center items-center"
            color="blue"
          >
            {key.En}
          </Tag>
        ))}
        <Link
          to={`/main-websites/manage-categories/${mainWebsiteId}/edit-keywords/${
            record.id
          }?page=${page + 1}&pageSize=${pageSize}`}
        >
          <Button type="link">
            <EditOutlined />
          </Button>
        </Link>
      </div>
    ),
  },
  {
    title: "Top 10 Articles",
    dataIndex: "top10List",
    key: "top10List",
    render: (_, record) => (
      <Top10ArticlesCategoriesPopOver
        id={mainWebsiteId}
        categoryId={record.id}
        page={page}
        pageSize={pageSize}
        top10Articles={record.top10articles}
      />
    ),
  },
  {
    title: "Actions",
    dataIndex: "id",
    key: "actions",
    render: (_, record) => (
      <div className="flex gap-2">
        <Link
          to={`/main-websites/manage-categories/${mainWebsiteId}/edit/${
            record.id
          }?page=${page + 1}&pageSize=${pageSize}`}
        >
          <Button type="link" icon={<EditOutlined />} />
        </Link>
        <Link
          to={`/main-websites/manage-categories/${mainWebsiteId}/edit-image/${
            record.id
          }?page=${page + 1}&pageSize=${pageSize}`}
        >
          <Button type="primary" icon={<TbImageInPicture />} />
        </Link>
        <Popconfirm
          title="Are you sure you want to delete this category?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="dashed" danger icon={<CiTrash />} />
        </Popconfirm>
      </div>
    ),
  },
];

export const MainWebsitesColumns = (
  page: number,
  pageSize: number,
  handleDelete: (id: string) => void
): TableProps<MainWebsiteTableDataType>["columns"] => [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        <TitlePopOver value={record.title} />
        <Link
          to={`/main-websites/edit-title/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link">
            <EditOutlined />
          </Button>
        </Link>
      </div>
    ),
  },
  {
    title: "Keywords",
    dataIndex: "keywords",
    key: "keywords",
    render: (_, record) => (
      <div className=" flex flex-row gap-2">
        {record.keywords.map((key: IMultiLanguage) => (
          <Tag
            title={`${key.Ar} - ${key.Fr}`}
            className="flex justify-center items-center"
            color="blue"
          >
            {key.En}
          </Tag>
        ))}
        <Link
          to={`/main-websites/edit-keywords/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link">
            <EditOutlined />
          </Button>
        </Link>
      </div>
    ),
  },

  {
    title: "Actions",
    dataIndex: "id",
    key: "actions",
    render: (_, record) => (
      <div className="flex gap-2">
        <Link
          to={`/main-websites/edit/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="link" icon={<EditOutlined />} />
        </Link>
        <Link
          to={`/main-websites/edit-image/${record.id}?page=${
            page + 1
          }&pageSize=${pageSize}`}
        >
          <Button type="primary" icon={<TbImageInPicture />} />
        </Link>
        <Popconfirm
          title="Are you sure you want to delete this website?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="dashed" danger icon={<CiTrash />} />
        </Popconfirm>
      </div>
    ),
  },
];
